// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2bsAp","image":"Header_image__3Y8L7","name":"Header_name__1RtKO","info":"Header_info__2yF8A","infoRow":"Header_infoRow__1UeL_"};